// import logo from './logo.png';
import './App.css';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import useStore from './store/index';
import useAuthStore from './store/auth';
import { Loading } from './components/Loading';
import { routes } from './routes';
import { useEffect } from 'react';
import { getAccounts, getCountries, getLanguages } from './adapters/utils';

function App() {
  const router = createBrowserRouter([ ...routes]);

  const setCountries = useStore((state) => state.setCountries);
  const setLanguages = useStore((state) => state.setLanguages);
  const setAccounts = useStore((state) => state.setAccounts);
  const authenticated = useAuthStore((state) => state.authenticated);
  useEffect(() => {
    if (authenticated){
      getCountries().then((res) => {
        if(res.status === 200){
          setCountries(res.data)
        }
  
        getLanguages().then((res) => {
          if(res.status === 200){
            setLanguages(res.data);
          }
        })
  
        getAccounts().then((res) => {
          if (res.status === 200) {
            setAccounts(res.data);
          }
        })
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, setCountries, setLanguages, setAccounts])

  return (
    <>
      <Loading initaite={false}/>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
